import { useState } from "react";
import { CalendarBlank, Clock } from "@phosphor-icons/react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

function fmt(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("en-US", {
    month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
  });
}

export default function DateTimePicker({ value, onChange, invalid, testId }) {
  const [open, setOpen] = useState(false);
  const date = value ? new Date(value) : null;
  const timeStr = date
    ? `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`
    : "17:00";

  const setDate = (d) => {
    if (!d) return;
    const [h, m] = timeStr.split(":").map(Number);
    const next = new Date(d);
    next.setHours(h, m, 0, 0);
    onChange(next.toISOString());
  };
  const setTime = (t) => {
    const [h, m] = t.split(":").map(Number);
    const base = date || new Date();
    const next = new Date(base);
    next.setHours(h, m, 0, 0);
    onChange(next.toISOString());
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={`flex items-center gap-2 w-full h-10 rounded-[var(--radius)] border bg-secondary px-3 text-sm text-left transition-colors ${
            invalid ? "border-destructive ring-1 ring-destructive/30" : "border-border hover:border-primary/40"
          }`}
        >
          <CalendarBlank size={17} className="text-muted-foreground shrink-0" />
          <span className={value ? "num" : "text-muted-foreground"}>{value ? fmt(value) : "Select date & time"}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-popover border-border" align="start">
        <Calendar mode="single" selected={date || undefined} onSelect={setDate} disabled={(d) => d < new Date(new Date().setHours(0, 0, 0, 0))} initialFocus />
        <div className="flex items-center gap-2 border-t border-border p-3">
          <Clock size={16} className="text-muted-foreground" />
          <input
            type="time"
            value={timeStr}
            onChange={(e) => setTime(e.target.value)}
            className="flex-1 h-9 rounded-lg border border-border bg-secondary px-2 text-sm num outline-none focus:border-primary"
            data-testid={testId ? `${testId}-time` : undefined}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}
